import React, { Component } from 'react';
import { Button, Form, Input, Segment } from 'semantic-ui-react';
import axios from 'axios';
import {
    fetchDisabledAccesses,
    fetchOrgUnitPropertiesByOrganizationalUnitId,
    fetchPropertiesByOrganizationalUnitId,
    fetchRoomTypes
} from '../Lookups/util';
import { checkFaculty, formatListForDropdownOptions } from '../util/util';
import { toast } from 'react-toastify';

class NewRoom extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            // Form data
            roomName: '',
            roomCode: '',
            roomType: null,
            floor: '',
            area: '',
            disabledAccess: null,
            property: null,
            seatCapacity: '',
            examSeatCapacity: ''

        };
        this.fetchLookups = this.fetchLookups.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this.fetchLookups(this.props.activeRole, this.props.organizationalUnitId);
    }


    fetchLookups(activeRole, organizationalUnitId) {
        axios.all([fetchDisabledAccesses(), fetchRoomTypes(), fetchPropertiesByOrganizationalUnitId()])
            .then(axios.spread((disabledAccessesRes, roomTypesRes, orgUnitPropertiesRes) => {
                const disabledAccesses = formatListForDropdownOptions(disabledAccessesRes.data);
                const roomTypes = formatListForDropdownOptions(roomTypesRes.data);
                const properties =

                        orgUnitPropertiesRes.data.map(el => ({
                            ...el, key: el.id, value: el.id, text: el.name,
                        }));

                this.setState({
                    disabledAccessesOptions: disabledAccesses,
                    roomTypeOptions: roomTypes,
                    propertyOptions: properties
                });
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch data.');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value !== '' ? value : null,
        });
    }

    sendRoomRequest() {
        const {
            roomName,
            roomCode,
            roomType,
            floor,
            area,
            disabledAccess,
            property,
            roomId,
            roomOptLock,
        } = this.state;
        if (roomName === null || roomName === '' || roomCode === null || roomCode === '' ||
            roomType === null || floor === null || floor === '' || area === '' ||
            area === null || (!this.props.property && property === null) || disabledAccess === null) {
            this.setState({
                roomNameError: roomName === null || roomName === '',
                roomCodeError: roomCode === null || roomCode === '',
                roomTypeError: roomType === null,
                floorError: floor === null || floor === '',
                areaError: area === null || area === '',
                propertyError: property === null,
                disabledAccessError: disabledAccess === null,
            });

            toast('Nisu sva potrebna polja popunjena!');
            return;
        }

        const roomRequest = {
            name: roomName,
            roomType: roomType ? { id: roomType } : null,
            code: roomCode,
            area,
            disabledAccess: disabledAccess ? { id: disabledAccess } : null,
            property: { id: this.props.property ? this.props.property.id : property },
            floor,
            seatCapacity: this.state.seatCapacity,
            examSeatCapacity: this.state.examSeatCapacity,
        };

        axios.post('/assets/rooms/', { ...roomRequest })
            .then(res => {
                this.props.fetchAllRooms();
                this.props.closeForm();
                toast('Uspješno ste dodali prostoriju.');
            })
            .catch(err => {
                console.log(err);
                toast('Došlo je do greške!');
            });
    }


    render() {
        return (
            <div>
                <Segment secondary clearing>
                    <Form noValidate>
                        <Form.Group widths="equal">
                            <Form.Field
                                control={Input}
                                label="Naziv prostorije"
                                name="roomName"
                                value={this.state.roomName}
                                onChange={this.handleInputChange}
                                placeholder="Unesite naziv prostorije"
                                required
                                error={this.state.roomNameError}
                            />

                            <Form.Field
                                control={Input}
                                label="Kod prostorije"
                                name="roomCode"
                                value={this.state.roomCode}
                                onChange={this.handleInputChange}
                                placeholder="Unesite kod prostorije"
                                required
                                error={this.state.roomCodeError}
                            />

                            <Form.Dropdown
                                clearable
                                label="Tip prostorije"
                                placeholder="Izaberite tip"
                                value={this.state.roomType}
                                options={this.state.roomTypeOptions}
                                onChange={this.handleInputChange}
                                name="roomType"
                                search
                                fluid
                                selection
                                required
                                error={this.state.roomTypeError}
                            />
                        </Form.Group>

                        <Form.Group widths="equal">
                            <Form.Field
                                label="Sprat"
                                type="number"
                                control={Input}
                                name="floor"
                                value={this.state.floor}
                                onChange={this.handleInputChange}
                                placeholder="Unesite sprat"
                                required
                                error={this.state.floorError}
                            />
                            <Form.Field
                                label="Površina (m²)"
                                type="number"
                                control={Input}
                                name="area"
                                value={this.state.area}
                                onChange={this.handleInputChange}
                                placeholder="Unesite površinu"
                                required
                                error={this.state.areaError}
                            />

                            <Form.Dropdown
                                clearable
                                label="Imovina"
                                placeholder="Izaberite imovinu"
                                value={this.props.property ? this.props.property.id : this.state.property}
                                options={this.state.propertyOptions}
                                onChange={this.handleInputChange}
                                name="property"
                                disabled={this.props.property}
                                search
                                fluid
                                selection
                                required
                                error={this.state.propertyError}
                            />
                        </Form.Group>

                        <Form.Group widths="equal">
                            <Form.Field
                                label="Broj mjesta"
                                type="number"
                                control={Input}
                                name="seatCapacity"
                                value={this.state.seatCapacity}
                                onChange={this.handleInputChange}
                                placeholder="Unesite broj mjesta"
                            />
                            <Form.Field
                                label="Broj mjesta za ispit"
                                type="number"
                                control={Input}
                                name="examSeatCapacity"
                                value={this.state.examSeatCapacity}
                                onChange={this.handleInputChange}
                                placeholder="Unesite broj mjesta za ispit"
                            />
                            <Form.Dropdown
                                clearable
                                label="Pristup invalidima"
                                value={this.state.disabledAccess}
                                onChange={this.handleInputChange}
                                options={this.state.disabledAccessesOptions}
                                name="disabledAccess"
                                placeholder="Izaberite pristup invalidima"
                                search
                                fluid
                                selection
                                required
                                error={this.state.disabledAccessError}
                            />
                        </Form.Group>

                        <Button
                            floated="right"
                            onClick={this.props.closeForm}
                            basic
                            color="blue"
                        >Odustani</Button>
                        <Button
                            floated="right"
                            color="blue"
                            onClick={
                                () => {
                                    this.sendRoomRequest();
                                }
                            }
                        >
                            Dodaj
                        </Button>
                    </Form>
                </Segment>
            </div>
        );
    }
}

export default NewRoom;



// WEBPACK FOOTER //
// ./src/views/Assets/Rooms/NewRoom.js